<template>
  <hl-Select
    size="sm"
    :value="value"
    :options="landlordOptions"
    label="Velg én utleierprofil"
    placeholder="Velg utleierprofil"
    placeholderValue="__NULL__"
    @input="$emit('input', arguments[0])"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import Select from '@modules/husleie-framework/src/components/forms/inputs/select/Select.vue';

export default {
  name: 'ReportSettingsLandlordSelector',

  components: {
    'hl-Select': Select,
  },

  props: {
    value: [String, Number],
  },

  computed: {
    ...mapGetters(['getLandlordProfilesMeta']),
    landlordOptions() {
      return this.getLandlordProfilesMeta.map(p => ({
        value: p.id,
        name: p.fullName,
      }));
    },
  },
};
</script>
